import React, { useEffect, useState, useRef } from 'react';

const FluidBackground = () => {
  const [scriptError, setScriptError] = useState(null);
  const canvasRef = useRef(null);
  
  // Initialize canvas with proper dimensions
  useEffect(() => {
    if (canvasRef.current) {
      canvasRef.current.width = window.innerWidth;
      canvasRef.current.height = window.innerHeight;
      
      // Add a global reference to the canvas that the script might be looking for
      window.canvas = canvasRef.current;
    }
    
    // Handle window resize
    const handleResize = () => {
      if (canvasRef.current) {
        canvasRef.current.width = window.innerWidth;
        canvasRef.current.height = window.innerHeight;
      }
    };
    
    window.addEventListener('resize', handleResize);
    
    return () => {
      window.removeEventListener('resize', handleResize);
      // Clean up global reference
      if (window.canvas === canvasRef.current) {
        window.canvas = null;
      }
    };
  }, []);
  
  // Create missing elements that the script is looking for
  useEffect(() => {
    // Create the promo elements that the script is trying to access
    const promoElement = document.createElement('div');
    promoElement.className = 'promo';
    promoElement.style.display = 'none'; // Hide it by default
    
    const promoCloseElement = document.createElement('div');
    promoCloseElement.className = 'promo-close';
    promoElement.appendChild(promoCloseElement);
    
    // Create app link elements
    const appleLink = document.createElement('a');
    appleLink.id = 'apple_link';
    appleLink.style.display = 'none';
    
    const googleLink = document.createElement('a');
    googleLink.id = 'google_link';
    googleLink.style.display = 'none';
    
    // Add elements to the body
    document.body.appendChild(promoElement);
    document.body.appendChild(appleLink);
    document.body.appendChild(googleLink);
    
    // Clean up on unmount
    return () => {
      if (document.body.contains(promoElement)) {
        document.body.removeChild(promoElement);
      }
      if (document.body.contains(appleLink)) {
        document.body.removeChild(appleLink);
      }
      if (document.body.contains(googleLink)) {
        document.body.removeChild(googleLink);
      }
    };
  }, []);
  
  // Load scripts with a delay to ensure DOM is ready
  useEffect(() => {
    // Wait a short time to ensure canvas and other elements are ready
    const timer = setTimeout(() => {
      // Add dat.gui dependency first
      const datGuiScript = document.createElement('script');
      datGuiScript.src = 'https://cdnjs.cloudflare.com/ajax/libs/dat-gui/0.7.7/dat.gui.min.js';
      datGuiScript.async = true;
      
      datGuiScript.onerror = (e) => {
        console.error('Error loading dat.gui:', e);
        setScriptError('Failed to load dat.gui library');
      };
      
      datGuiScript.onload = () => {
        // Add a small delay before loading the fluid script
        setTimeout(() => {
          // Import the script after dat.gui is loaded
          import('../../script/FluidScript.js')
            .then(() => {
              console.log('FluidScript loaded successfully');
              
              // Hide the dat.gui panel after a short delay to ensure it's created
              setTimeout(() => {
                const datGuiContainer = document.querySelector('.dg.ac');
                if (datGuiContainer) {
                  datGuiContainer.style.display = 'none';
                }
              }, 300);
            })
            .catch((error) => {
              console.error('Error loading FluidScript.js:', error);
              setScriptError(`Failed to load script: ${error.message}`);
            });
        }, 100);
      };
      
      document.body.appendChild(datGuiScript);
    }, 200);
    
    // Clean up on unmount
    return () => {
      clearTimeout(timer);
      
      // Remove any scripts we added
      const datGuiScript = document.querySelector('script[src="https://cdnjs.cloudflare.com/ajax/libs/dat-gui/0.7.7/dat.gui.min.js"]');
      if (datGuiScript && document.body.contains(datGuiScript)) {
        document.body.removeChild(datGuiScript);
      }
    };
  }, []);
  
  return (
    <>
      <canvas 
        ref={canvasRef} 
        id="fluid-canvas" 
        className="fluid-canvas"
      ></canvas>
      
      {scriptError && (
        <div className="script-error-message">
          {scriptError}
        </div>
      )}
      
      <style>
        {`
          .fluid-canvas {
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            z-index: 0;
            pointer-events: none;
          }
          
          .dg.ac {
            display: none !important;
          }
          
          .promo {
            display: none;
          }
          
          .script-error-message {
            position: fixed;
            top: 20px;
            left: 50%;
            transform: translateX(-50%);
            background-color: #ff5252;
            color: white;
            padding: 10px 20px;
            border-radius: 5px;
            z-index: 1000;
          }
        `}
      </style>
    </>
  );
};

export default FluidBackground; 